export enum ChartAnimationEasing {
    linear,
    in,
    out,
    inAndOut
}